import React/*, {useState}*/ from 'react';
import {postApi, reportImage} from '../../../utils/functions';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

export default class Socials extends React.Component {
	//static contextType = UserContext;
  constructor(props) {
		super(props);
		this.state = {
			socials: {},
			user: this.props.user,
		};
	}

	async componentDidMount() {
		const params = new URLSearchParams();
		const x = await postApi('/v3/account/socials', params);
		this.setState({socials: x.data.socials});
	}

	render() {
		const socials = Object.keys(this.state.socials).map((e,i) => {
			let url = this.state.user[e];
			if( url ) {
				if( url.indexOf('https://') !== 0 ) {
					url = `${this.state.socials[e].placeholder}${url}`;
				}
				return (
					<React.Fragment key={i}>
						{this.state.user[e] &&
							<a href={url} target="_blank" rel="noreferrer">
								<span className="btn btn-sm  btn-info-light btn-wave waves-effect waves-light">
									{/*<FontAwesomeIcon icon={[this.state.socials[e].icon[0], this.state.socials[e].icon[1]]} className="fw-bold" />*/}
									<img src={`https://cloud.ultrastream.io/images/platforms/${this.state.socials[e].image}`} width={24} height={24} onError={reportImage} />
								</span>
							</a>
						}
					</React.Fragment>
				)
			} else {
				return null;
			}
		})
		return (
			<div className="btn-list text-center">
				<div className="btn-list">
					{socials}
				</div>
			</div>
		)
	}
}
